/**
 * Générateur — Automatisme : diviser des fractions.
 * Attendu ID : 1216 | Niveau : 3ème | Domaine : Nombres rationnels
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 11, ligne 728).
 *
 * Les clés quotient_* de gen_1213 (un fichier « fractions », quatre jeux de clés,
 * modèle 1246/1247/1248, base du prof du 13/09) : la mécanique, les
 * distracteurs et les sacrifiés sont ceux de gen_1213 ; les payloads
 * portent déjà l'attendu 1216.
 */
import { genererParmi, CATEGORIES_QUOTIENT } from './gen_1213';

export const CATEGORIES = CATEGORIES_QUOTIENT;
const CLES = CATEGORIES_QUOTIENT.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
